<template>
  <div class="ml-auto" :class="gClass">
    <Dropdown :hasTooltip="true" tooltipType="group" :hideArrow="true" ref="moreAction" class="ml-auto" bclass="btn-block gp_dropdown-button" lclass>
      <template v-slot:button>
        <i>
          <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M3.42631 8.79242C3.22109 8.84723 3.02711 8.95512 2.86612 9.11612C2.37796 9.60427 2.37796 10.3957 2.86612 10.8839C3.35427 11.372 4.14573 11.372 4.63388 10.8839C4.79488 10.7229 4.90277 10.5289 4.95758 10.3237C5.06894 9.90667 4.96105 9.44328 4.63388 9.11612C4.30672 8.78895 3.84333 8.68106 3.42631 8.79242Z" fill="#676767"/>
            <path d="M17.1339 10.8839C17.622 10.3957 17.622 9.60427 17.1339 9.11612C16.6457 8.62796 15.8543 8.62796 15.3661 9.11612C14.878 9.60427 14.878 10.3957 15.3661 10.8839C15.8543 11.372 16.6457 11.372 17.1339 10.8839Z" fill="#676767"/>
            <path d="M10.8839 9.11612C11.372 9.60427 11.372 10.3957 10.8839 10.8839C10.3957 11.372 9.60427 11.372 9.11612 10.8839C8.62796 10.3957 8.62796 9.60427 9.11612 9.11612C9.60427 8.62796 10.3957 8.62796 10.8839 9.11612Z" fill="#676767"/>
          </svg>
        </i>
      </template>
      <div class="gp_dropdown-setting d-flex align-items-center" @click="openModal('rename')">
        <!-- <img :src="publicPath + require('@/core/assets/icon-settings/rename.svg')" /> -->
        <i class="icon icon-rename typo-icon-16"></i>
        <p class="typo-button14 ml-1">{{ $t("group.rename") }}</p>
      </div>
      <div class="gp_dropdown-setting d-flex align-items-center" @click="openModal('ungroup')">
        <!-- <img :src="publicPath + require('@/core/assets/icon-settings/ungroup.svg')" /> -->
        <i class="icon icon-ungroup typo-icon-16"></i>
        <p class="typo-button14 ml-1">{{ $t("group.ungroup") }}</p>
      </div>
      <!-- <div class="gp_dropdown-setting d-flex align-items-center" @click="openModal('delete')">
        <i class="icon icon-delete typo-icon-16 text-danger"></i>
        <p class="typo-button14 ml-1 text-danger">{{ $t("generals.delete") }}</p>
      </div> -->
    </Dropdown>

    <!-- Modal -->
    <Modal :hideExit="true" @cancel="closeModal" v-if="modalActive" cClass="mw424">
      <template #header>
        <p class="typo-title1" :class="danger">{{ titleModal }}</p>
      </template>
      <template #default>
        <!-- Body Rename -->
        <template v-if="currentModal == 'rename'">
          <div class="col-12 p-0">
            <div class="form-group">
              <label class="typo-body2 label text-black1">{{ $t("group.groupTitle") }}</label>
              <input ref="inputTitle" v-focus class="input-field input-field-block" type="text" v-model="groupName" />
            </div>
          </div>
        </template>

        <!-- Body Move To New Group -->
        <template v-if="currentModal == 'ungroup'">
          <div class="col-12 p-0">
            <p class="typo-paragraph14 typo-regular-150 text-light-low" v-html="$t('group.ungroupDesc')"></p>
          </div>
        </template>

        <!-- Body Delete -->
        <template v-if="currentModal == 'delete'">
          <div class="col-12 p-0">
            <div class="form-group">
              <label class="mb-1 typo-paragraph14 typo-regular-150 text-light-low"
                >{{ $t("group.deleteDesc") }} <span class="typo-paragraph14 typo-regular-150  text-light-high">"{{ group.name }}"</span> {{ $t("group.deleteDesc2") }}</label
              >
              <input ref="inputTitle" v-focus class="input-field input-field-block" type="text" v-model="retypeDelete" />
              <p v-if="alertText" class="typo-paragraph12 typo-italic text-danger mt-half">{{ alertText }}</p>
            </div>
          </div>
        </template>
      </template>
      <template #footer>
        <div class="btn-group flex-row-reverse" v-if="currentModal != 'share'">
          <!-- Footer -->
          <template v-if="currentModal == 'rename'">
            <button class="btn btn-primary ml-1" @click="doSubmit">{{ textSubmitButton }}</button>
            <button class="btn btn-outline" @click="closeModal">{{ $t("generals.cancel") }}</button>
          </template>

          <template v-if="currentModal == 'ungroup'">
            <button class="btn btn-outline ml-1" @click="doSubmit">{{ textSubmitButton }}</button>
            <button class="btn btn-primary" @click="closeModal">{{ $t("generals.cancel") }}</button>
          </template>

          <template v-if="currentModal == 'delete'">
            <button class="btn btn-outline ml-1" @click="doSubmit">{{ textSubmitButton }}</button>
            <button class="btn btn-primary" @click="closeModal">{{ $t("generals.cancel") }}</button>
          </template>
        </div>
      </template>
    </Modal>
  </div>
</template>

<script>
import { mapActions } from "vuex";
export default {
  props: {
    group: Object,
    gClass: String,
    pageType: String,
    disableUngroup: {
      type: Boolean,
      default: false
    },
    iClass: {
      type: String,
      default: "typo-icon-20"
    }
  },
  data() {
    return {
      currentModal: "",
      modalActive: false,
      retypeDelete: "",
      alertText: "",
      groupName: ""
    };
  },
  computed: {
    textSubmitButton() {
      switch (this.currentModal) {
        case "rename":
          return this.$t("generals.save");
        case "ungroup":
          return this.$t("group.ungroup");
        case "delete":
          return this.$t("generals.delete");
      }
      return "";
    },
    titleModal() {
      switch (this.currentModal) {
        case "rename":
          return this.$t("group.rename");
        case "ungroup":
          return this.$t("group.ungroup");
        case "delete":
          return this.$t("generals.delete") + " " + this.$tc("group.group");
      }
      return "";
    },
    danger() {
      return this.currentModal == "delete" ? "text-danger" : "";
    }
  },
  created() {
    this.groupName = this.group.name;
  },
  methods: {
    ...mapActions("group", {
      updateGroup: "updateGroup",
      deleteGroup: "deleteGroup"
    }),
    doSubmit() {
      switch (this.currentModal) {
        case "rename":
          this.rename();
          break;
        case "ungroup":
          this.ungroup();
          break;
        case "delete":
          this.delete();
          break;
      }
    },
    rename() {
      let groupUpdated = {
        id: this.group.id,
        name: this.groupName
      };
      this.gSnackbarCommit({
        message: this.$t("status.processing"),
        type: "loading"
      });
      this.updateGroup({
        pageType: this.pageType,
        groupUpdated: groupUpdated
      })
        .then(() => {
          this.gSnackbarCommit({
            message: this.$t("status.success"),
            type: "success"
          });
        })
        .catch(() => {
          this.gSnackbarCommit({
            message: this.$t("status.error"),
            type: "error"
          });
        });
      this.closeModal(false);
    },
    ungroup() {
      let textSuccess = this.$t("status.success");
      let textError = this.$t("status.error");
      this.gSnackbarCommit({
        message: this.$t("status.processing"),
        type: "loading"
      });
      this.deleteGroup({
        groupId: this.group.id,
        pageType: this.pageType
      })
        .then(() => {
          this.gSnackbarCommit({
            message: textSuccess,
            type: "success"
          });
          this.$emit("onUngroupSuccess");
          this.$root.$emit("onUngroupSuccess");
        })
        .catch(() => {
          this.gSnackbarCommit({
            message: textError,
            type: "error"
          });
        });
      this.closeModal(false);
    },
    delete() {
      if (this.group.name.trim() == this.retypeDelete.trim()) {
        this.alertText = "";
        this.gSnackbarCommit({
          message: this.$t("status.processing"),
          type: "loading"
        });
        this.deleteGroup({
          groupId: this.group.id,
          removePages: true,
          pageType: this.pageType
        })
          .then(() => {
            this.gSnackbarCommit({
              message: this.$t("status.success"),
              type: "success"
            });
          })
          .catch(() => {
            this.gSnackbarCommit({
              message: this.$t("status.error"),
              type: "error"
            });
          });
        this.closeModal(false);
      } else {
        this.alertText = this.$t("group.wrongName");
      }
    },
    closeModal(userClose = true) {
      if (userClose){
        this.groupName = this.group.name;
      }
      this.currentModal = "";
      this.modalActive = false;
    },
    openModal(modalType) {
      // if (modalType == "ungroup" && this.disableUngroup) return;
      this.currentModal = modalType;
      this.modalActive = "true";
    }
  }
};
</script>

<style lang="scss" scoped>
::v-deep .gp_dropdown-button {
  &.active {
    background: $textDarkModeHigh;
  }
}
</style>
